import { render, staticRenderFns } from "./Paginationdeltop.vue?vue&type=template&id=3ba55e97&scoped=true"
import script from "./Paginationdeltop.vue?vue&type=script&lang=js"
export * from "./Paginationdeltop.vue?vue&type=script&lang=js"
import style0 from "./Paginationdeltop.vue?vue&type=style&index=0&id=3ba55e97&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba55e97",
  null
  
)

export default component.exports